import {
    IconCalendarOutline,
    IconPercent,
    IconPound,
    IconQuestionMarkFilled
} from '@iwoca/icons';
import { Pill, Text } from '@iwoca/orion';
import { NEW_IwLinkButton } from '@iwRouter/NEW_IwLinkButton';
import { H1 } from '@ui';
import { FormattedMessage } from 'react-intl';

import { ONBOARDING_BASE_URL } from '../constants';

export const CreditCardOffer = () => {
    return (
        <div className="w-full bg-structure-100 py-5xl text-center">
            <section className="grid grid-cols-4">
                <Text className="col-span-2 col-start-2 text-center text-2xl font-bold">
                    <FormattedMessage
                        id="_.credit_card.decline.flexi_decline_message"
                        defaultMessage="Sorry, we can’t approve your application for a Flexi-Loan today."
                    />
                </Text>
            </section>

            <section className="my-xl text-center">
                <Text>
                    <FormattedMessage
                        id="_.credit_card.approved.message"
                        defaultMessage="But you are approved for:"
                    />
                </Text>

                <div className="m-auto mt-xl grid max-w-2xl grid-cols-2 rounded-l border border-secondary-90 p-xl shadow-blue-m max-sm:mx-s max-sm:grid-cols-1">
                    <div className="col-span-1 mr-l pb-xl text-left">
                        <H1 className="text-2xl font-bold">
                            <FormattedMessage
                                id="_.credit_card.offer.title"
                                defaultMessage="iwoca credit card"
                            />
                        </H1>
                        <Pill variant="green" size="small" className="my-s">
                            <Text className="text-xs font-med text-success-drk">
                                <FormattedMessage
                                    id="_.credit_card.offer.approved"
                                    defaultMessage="You are approved"
                                />
                            </Text>
                        </Pill>
                        <Text className="text-m">
                            <FormattedMessage
                                id="_.credit_card.offer.first_customers_test"
                                defaultMessage="Be one of the first customers to access our new product."
                            />
                        </Text>
                        <NEW_IwLinkButton
                            variant="primary"
                            to={{ pathname: ONBOARDING_BASE_URL }}
                            className="mt-m w-full"
                        >
                            <Text className="text-s font-bold text-secondary-95">
                                <FormattedMessage
                                    id="_.credit_card.offer.get_your_card.cta"
                                    defaultMessage="Get your credit card"
                                />
                            </Text>
                        </NEW_IwLinkButton>
                    </div>

                    <div className="col-span-1 ml-m flex flex-col gap-l">
                        <div className="flex flex-row gap-m">
                            <IconPound className="text-xl" />
                            <Text className="text-m font-med max-sm:text-s">
                                <FormattedMessage
                                    id="_.credit_card.offer.credit_limit"
                                    defaultMessage="£1,000 credit limit"
                                />
                            </Text>
                        </div>
                        <div className="flex flex-row gap-m">
                            <IconQuestionMarkFilled className="text-xl" />
                            <Text className="text-m font-med max-sm:text-s">
                                <FormattedMessage
                                    id="_.credit_card.offer.cashback"
                                    defaultMessage="1% cashback on every transaction"
                                />
                            </Text>
                        </div>
                        <div className="flex flex-row gap-m">
                            <IconCalendarOutline className="text-xl" />
                            <Text className="text-m font-med max-sm:text-s">
                                <FormattedMessage
                                    id="_.credit_card.offer.interest_free"
                                    defaultMessage="Up to 42 days interest-free"
                                />
                            </Text>
                        </div>
                        <div className="flex flex-row gap-m">
                            <IconPercent className="text-xl" />
                            <Text className="text-m font-med max-sm:text-s">
                                <FormattedMessage
                                    id="_.credit_card.offer.apr"
                                    defaultMessage="35.4% APR"
                                />
                            </Text>
                        </div>
                        <div className="flex flex-row gap-m">
                            <IconQuestionMarkFilled className="text-xl" />
                            <Text className="text-m font-med max-sm:text-s">
                                <FormattedMessage
                                    id="_.credit_card.offer.mobile_app"
                                    defaultMessage="Manage everything with an app"
                                />
                            </Text>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};
